var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvoicing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.824,
    height: 41.129,
    viewBox: "0 0 40.824 41.129",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Invoicing",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147",
    "data-name": "Rectangle 147",
    width: 2.151,
    height: 2.246,
    transform: "translate(0.003 13.354)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1467",
    "data-name": "Path 1467",
    d: "M344.438,431.49H323.39v15.073h21.048Zm-18.884,2.166h10.5V444.4h-10.5ZM342.274,444.4h-4.05V433.656h4.05Z",
    transform: "translate(-318.454 -409.507)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1468",
    "data-name": "Path 1468",
    d: "M601.2,186.745a3.652,3.652,0,0,1-2.7-1.2h3.218V183.4h-4.166c-.009-.1-.016-.209-.016-.316,0-.072.007-.142.011-.212h4.169v-2.151H598.4a3.661,3.661,0,0,1,6.215,1.049l2.008-.772a5.813,5.813,0,0,0-10.739-.277h-1.7v2.151h1.2c0,.068-.011.141-.011.212,0,.107.01.21.016.316H594.19v2.151h1.748a5.811,5.811,0,0,0,10.737-.507l-2.026-.725A3.675,3.675,0,0,1,601.2,186.745Z",
    transform: "translate(-570.76 -172.642)",
    fill: "#ec0000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1469",
    "data-name": "Path 1469",
    d: "M291.944,120.237a10.634,10.634,0,0,0-13.178-10.328,5.07,5.07,0,0,0-1.707-.3h-15.9L251.12,119.65l.013,1.562,2.151-.018v-.025H262.8v-9.408h12.088a10.739,10.739,0,0,0-2.454,2.619H266.7v2.151h4.638a10.606,10.606,0,0,0-.365,6.215H255.943V124.9h15.805a10.677,10.677,0,0,0,1.4,2.151H256.182V129.2h19.362v-.031a10.568,10.568,0,0,0,4.47,1.622v14.831a2.959,2.959,0,0,1-2.956,2.955H256.234a2.959,2.959,0,0,1-2.956-2.955V127.447h-2.151v18.175a5.113,5.113,0,0,0,5.107,5.106h20.83a5.113,5.113,0,0,0,5.107-5.106V130.836A10.648,10.648,0,0,0,291.944,120.237Zm-37.148-1.22,5.852-5.852v5.852Zm26.511,9.706a8.481,8.481,0,0,1-2.713-16.518c.036.023.075.04.111.064l.094-.137a8.486,8.486,0,1,1,2.509,16.6Z",
    transform: "translate(-251.12 -109.6)",
    fill: "#ec0000"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoicing);
export default __webpack_public_path__ + "static/media/Invoicing.b069690062f982657dd6cb2b22edcb9f.svg";
export { ForwardRef as ReactComponent };